export default __webpack_public_path__ + "564e3f217f175777d7eec1f2069123a1.svg";